<template lang="html">
  <div>
    <md-layout v-if="!enRegistro">
      <md-layout md-align="center" md-flex="100">
        <h2 style="text-align:center">¡BIENVENIDO!</br></br> Por Favor ingrese sus datos en los campos de abajo para Iniciar Sesión</h2>
      </md-layout>
      
      <md-layout v-if ="parametros.ocultar_precios === 0 || parametros.ocultar_precios === '0'" md-flex="100" md-align="center">
        <md-layout md-flex="100" md-align="center">
          <h2>Si usted no tiene cuenta con nosotros, haga click en el boton "Crear cuenta nueva"</h2>
        </md-layout>
        <md-layout md-flex="100" md-align="center">
          <md-button class="md-primary md-raised" id="crear" @click.native="enRegistro = true" >Crear cuenta nueva</md-button>
        </md-layout>
      </md-layout>
      

      <md-layout md-align="center" md-flex="100">
        <!-- <md-layout></md-layout> -->
        <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
          <md-input-container>
            <md-icon>perm_identity</md-icon>
            <label>Nombre de usuario</label>
            <md-input v-model="usuario.usuario"></md-input>
          </md-input-container>
          <md-input-container>
            <md-icon>lock_outline</md-icon>
            <label>Contraseña</label>
            <md-input v-model="usuario.contrasena" type="password"></md-input>
          </md-input-container>
        </md-layout>
        <md-layout md-flex="100"></md-layout>
        <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
          <span @click="openModal('PassDialog')">
            <div id="ForgotPassword">¿Olvido su contraseña? haga click sobre este texto</div>
          </span>
        </md-layout>
        <md-layout md-flex="100"></md-layout>
        <md-layout md-align="end" md-flex="50" md-flex-small="100" md-flex-xsmall="100">
            <md-button class="md-accent" id="cancelar" @click.native="closeModal('logInDialog')">Cancelar</md-button>
            <md-button class="md-primary md-raised" id="entrar" @click.native="logIn">Iniciar Sesión</md-button>
        </md-layout>

      </md-layout>
      <md-layout v-if="parametros.ocultar_precios !== 0 && parametros.ocultar_precios !== '0'" md-flex="100" md-align="center">
        <h3>Si usted no tiene cuenta con nosotros, favor de solicitar su registro al numero {{empresa.telefono + ' '}} 
            o mediante correo electronico a {{empresa.email  + ' '}}</h3>
      </md-layout>
    </md-layout> 

    <md-layout v-else>

      <md-layout md-flex="100" md-align="center">
        <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
          
          <md-layout md-flex="100" v-if="paso === 'nombre'">
            <h3>Bienvenido al proceso de registro, para empezar ingrese su nombre completo en el campo de abajo</h3>
            <md-layout md-flex="100" >
              <md-input-container>
                <label>Nombre Completo</label>
                <md-input required v-model="usuarioRegistro.cliente.nombre"></md-input>
              </md-input-container>
            </md-layout>
          </md-layout>

          <md-layout md-flex="100" v-if="paso === 'email'">
            <h3>Ahora ingrese su email, es importante en caso de olvidar su contraseña</h3>
            <md-layout md-flex="100">
              <md-input-container>
                <label>Email</label>
                <md-input required v-model="usuarioRegistro.cliente.email"></md-input>
              </md-input-container>
            </md-layout>
          </md-layout>

          <md-layout md-flex="100" v-if="paso === 'telefono'">
            <h3>Perfecto! Ingrese su numero de telefono, este paso es opcional, si no desea proporcionarlo de click en continuar</h3>
            <md-layout md-flex="100">
              <md-input-container>
                <label>Telefono</label>
                <md-input required v-model="usuarioRegistro.cliente.telefono"></md-input>
              </md-input-container>
            </md-layout>
          </md-layout>

          <md-layout md-flex="100" v-if="paso === 'direccion'" md-gutter="16">
            <h3>A continuación ingresa tu direccion porfavor</h3>
            <md-layout md-flex="60" md-flex-small="100" md-flex-xsmall="100">
              <md-input-container>
                <label>Direccion</label>
                <md-input required v-model="usuarioRegistro.cliente.direccion"></md-input>
              </md-input-container>
            </md-layout>
            <md-layout md-flex="20" md-flex-small="50" md-flex-xsmall="50">
              <md-input-container>
                <label>Numero exterior</label>
                <md-input required v-model="usuarioRegistro.cliente.numext"></md-input>
              </md-input-container>
            </md-layout>
            <md-layout md-flex="20" md-flex-small="50" md-flex-xsmall="50">
              <md-input-container>
                <label>Numero interior</label>
                <md-input required v-model="usuarioRegistro.cliente.numint"></md-input>
              </md-input-container>
            </md-layout>
            <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
              <md-input-container>
                <label>Colonia</label>
                <md-input required v-model="usuarioRegistro.cliente.colonia"></md-input>
              </md-input-container>
            </md-layout>
            <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
              <md-input-container>
                <label>Ciudad</label>
                <md-input required v-model="usuarioRegistro.cliente.poblacion"></md-input>
              </md-input-container>
            </md-layout>
            <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
              <md-input-container>
                <label>Estado</label>
                <md-input required v-model="usuarioRegistro.cliente.entfed"></md-input>
              </md-input-container>
            </md-layout>
            <md-layout md-flex="50" md-flex-small="50" md-flex-xsmall="50">
              <md-input-container>
                <label>CP</label>
                <md-input required v-model="usuarioRegistro.cliente.cp"></md-input>
              </md-input-container>
            </md-layout>
            <md-layout md-flex="50" md-flex-small="50" md-flex-xsmall="50">
              <md-input-container>
                <label>Pais</label>
                <md-input required v-model="usuarioRegistro.cliente.pais"></md-input>
              </md-input-container>
            </md-layout>
          </md-layout>

          <md-layout md-flex="100" v-if="paso === 'usuario'">
            <h3>Ahora escoga un nombre de usuario, servira para su inicio de sesion</h3>
            <md-layout md-flex="100">
              <md-input-container>
                <label>Nombre de Usuario</label>
                <md-input required v-model="usuarioRegistro.cliente.usuario"></md-input>
              </md-input-container>
            </md-layout>
          </md-layout>

          <md-layout md-flex="100" v-if="paso === 'contrasena'">
            <h3>Por ultimo ingrese una contraseña, le recomendamos anotarla para no olvidarla</h3>
            <md-layout md-flex="100">
              <md-input-container>
                <label>Contraseña</label>
                <md-input required v-model="usuarioRegistro.sTShop.contrasena"></md-input>
              </md-input-container>
            </md-layout>
          </md-layout>

        </md-layout>
        <md-layout md-flex="100"></md-layout>
        <md-layout md-align="end" md-flex="50" md-flex-small="100" md-flex-xsmall="100">
            <md-button class="md-primary " id="entrar" @click.native="retroceder">atras</md-button>
            <md-button class="md-primary md-raised" id="entrar" @click.native="validar">Continuar</md-button>
        </md-layout>

      </md-layout>
    </md-layout> 



    <md-dialog ref="PassDialog" id="PassDialog">
      <md-dialog-title style="padding:0">
        <md-toolbar>
          <div class="md-title">Recuperar Contraseña</div>
        </md-toolbar>
      </md-dialog-title>
      <md-dialog-content>
        <md-layout md-column>
          <md-input-container>
            <md-icon>perm_identity</md-icon>
            <label>Email</label>
            <md-input v-model="emailRecupera"></md-input>
          </md-input-container>
        </md-layout>
      </md-dialog-content>
      <md-dialog-actions>
        <md-layout>
          <md-layout md-align="end">
            <md-button class="md-accent" id="cancelar" @click.native="closeModal('PassDialog')">Cancelar</md-button>
            <md-button class="md-primary md-raised" id="entrar" @click.native="resetPass">Recuperar Contraseña</md-button>
          </md-layout>
        </md-layout>
      </md-dialog-actions>
    </md-dialog>
    
     
  </div>
</template>

<script type="text/javascript">
import { toMoney } from "../../common/functions/helpers";
import Email from '../../common/functions/smtp'

export default {
  name: "Login",
  data() {
    return {
      resourcePedido: this.$api.pedido(this.$resource),
      resourceCliente: this.$api.cliente(this.$resource),
      resourceArticulos: this.$api.articulo(this.$resource),
      cart:[],
      isLogged: false,
      parametros: {},
      empresa: {},
      ultimaPagina:'',
      emailRecupera: '',
      enRegistro: false,
      usuario: {
        usuario: '',
        contrasena: '',
      },
      paso:'nombre',
      usuarioRegistro: {
        confirmaContrasena: '',
        cliente: {
          email: '',
          nombre:'',
          comercial: '',
          rfc: '',
          direccion: '',
          numext: '',
          numint: '',
          pais: '',
          entfed: '',
          poblacion: '',
          colonia: '',
          cp: '',
        },
        sTShop: {
          contrasena: '',
        },
      },
    };
  },
  computed: {},
  components: {},
  methods: {
    logIn() {
      this.resourceCliente.logIn(this.usuario)
        .then((response) => {
          window.cliente = response.body;
          this.isUserLogged = true;
          localStorage.setItem('cliente', JSON.stringify(response.body));
          // const route = this.$route.name;
          this.$toast.create('Se inicio sesión correctamente', 'snack', 3E3);
          debugger
          this.$root.$emit('setCliente');
          this.$router.replace({ name: 'perfil' }); 
          
        })
        .catch((err) => {
          this.$toast.create('Usuario o Contraseña incorrectos', 'snack', 3E3);
        });
    },
    resetPass() {
      const email = this.emailRecupera
      this.resourceCliente.RecuperaPass({email})
        .then((response) => {
          // this.enviarMailPassword(response.body);
          this.closeModal('PassDialog')
        })
        .catch((err) => {
          debugger
          this.$toast.create('No se encontro un usuario con ese email', 'snack', 3E3);
        });
    },
    enviarMailPassword(data){ 
      debugger  
      const mail = `<html><head></head><body><div style='margin-left:auto; margin-right: auto; width:650px;'><table style='width:650px; font-size:14px'><tr><td><img style='max-height: 90px; max-width: 350px' src='${this.parametros.ruta_imagen}${data.empresa.foto}' alt='No se encontro la imagen' /></td><td style='text-align: right'><b>${data.empresa.nombre}</b>  <br>${data.empresa.direccion} ${data.empresa.num_ext} (${data.empresa.num_int})  <br>${data.empresa.colonia}, ${data.empresa.cp}  <br>${data.empresa.poblacion}, ${data.empresa.entfed}, ${data.empresa.pais}</td></tr></table><br><br><table style='width:650px; font-size:22px'><tr><td style='margin-left:auto; margin-right:auto; text-align:center'><b>Recuperación de contraseña</b></td></tr></table><br><table style='width:650px'><tr><td style='margin-left:auto; margin-right:auto'><b>Haz solicitado una nueva contraseña de acceso para STSHOP</b></td></tr></table><br><table style='border:1px solid #acb7c0; border-radius: 10px; width:650px; '><tr><td style='text-align: left; padding: 10px'><a href='${this.parametros.sitio}' target="_blank">Ingresa al sistema con los siguientes datos:</a><br><br>Usuario: ${data.cliente.usuario}<br>Contraseña: ${data.cliente.contrasena} <br><br>Posteriormente te recomendamos cambiar la contraseña en la seccion "Mi información"</td></tr></table><br><br><table style='width:650px;font-size:14px; font-style: oblique;'>  <tr><td style='width:480px;text-align: right'>  <img style='max-height: 50px;' src='https://stshop.club:85/stshopc.png  ' alt='No se encontro la imagen' /></td><td style='text-align: right'>STShop (<a href='http://www.superticket.mx'>superticket.mx</a>)</td>  </tr></table></div></body></html>`
      Email.send({
        SecureToken: "5e63cd26-a2a6-41f6-9465-003da40dc9ea",
        To : data.cliente.email,
        From : "controlatutienda@gmail.com",
        Subject : `Recuperación de Contraseña STSHOP`,
        Body : mail
      }).then((message) => {
          debugger
          alert(message)
        }
      ).catch(err =>{
        alert(err);
      });
    },
    retroceder(){
      if(this.paso ==='nombre'){

      } else if(this.paso ==='email'){
       this.paso = 'nombre';
      } else if(this.paso ==='direccion'){
       this.paso = 'email';
      } else if(this.paso ==='telefono'){
        this.paso = 'direccion';
      } else if(this.paso ==='usuario'){
        this.paso = 'telefono';
      } else if(this.paso ==='contrasena'){
        this.paso = 'usuario';
      }
    },
    validar(){
      if(this.paso ==='nombre'){
        if (this.usuarioRegistro.cliente.nombre && this.usuarioRegistro.cliente.nombre.length > 0) {
          this.usuarioRegistro.cliente.comercial = this.usuarioRegistro.cliente.nombre;
          this.paso = 'email'
        } else {
          alert('Por favor ingresa tu nombre antes de continuar')
        }
        return;
      }
      if(this.paso ==='email'){
        if (this.usuarioRegistro.cliente.email && this.usuarioRegistro.cliente.email.length > 0) {
          this.paso = 'direccion'
        } else {
          alert('Por favor ingresa tu email antes de continuar')
        }
        return;
      }
      if(this.paso ==='direccion'){
        if (this.usuarioRegistro.cliente.direccion && this.usuarioRegistro.cliente.direccion.length > 0) {
          if (this.usuarioRegistro.cliente.numext && this.usuarioRegistro.cliente.numext.length > 0) {
            if (this.usuarioRegistro.cliente.poblacion && this.usuarioRegistro.cliente.poblacion.length > 0) {
              if (this.usuarioRegistro.cliente.cp && this.usuarioRegistro.cliente.cp.length > 0) {
                if (this.usuarioRegistro.cliente.entfed && this.usuarioRegistro.cliente.entfed.length > 0) {
                  this.paso = 'telefono'
                }else{alert('Por favor ingresa tu estado antes de continuar')}
              }else{alert('Por favor ingresa tu codigo postal antes de continuar')}
            }else{alert('Por favor ingresa tu ciudad antes de continuar')}
          } else{alert('Por favor ingresa el numero exterior antes de continuar')}
        } else {
          alert('Por favor ingresa tu direccion antes de continuar')
        }
        return;
      }
      if(this.paso ==='telefono'){
        this.paso = 'usuario'
        return;
      }
      if(this.paso ==='usuario'){
        if (this.usuarioRegistro.cliente.usuario && this.usuarioRegistro.cliente.usuario.length > 0) {
          this.paso = 'contrasena'
        } else {
          alert('Por favor ingresa un nombre de usuario antes de continuar')
        }
        return;
      }
      if(this.paso ==='contrasena'){
        if (this.usuarioRegistro.sTShop.contrasena && this.usuarioRegistro.sTShop.contrasena.length > 0) {
          this.registro()
        } else {
          alert('Por favor ingresa una contraseña antes de continuar')
        }
      }
    },
    registro() {
        this.usuarioRegistro.sTShop.usuario = this.usuarioRegistro.cliente.usuario
        this.usuarioRegistro.sTShop.email = this.usuarioRegistro.cliente.email
        this.usuarioRegistro.sTShop.RFC = this.usuarioRegistro.cliente.rfc
        this.resourceCliente.crear(this.usuarioRegistro)
        .then((response) => {
          if(response === 'email'){
            alert('Ya existe una cuenta con el email ingresado');
            this.paso = 'email'
          }else if(response === 'usuario'){
            alert('Ya existe una cuenta con el usuario ingresado, favor de cambiarlo');
          }
          const idusuario = response.body.idinterno;
            alert('Se registro correctamente, Por favor inicie sesion para continuar');
            // this.checkCliente();
            this.enRegistro = false;

        })
        .catch((err) => {
          this.$toast.create('Ocurrio un error en el registro', 'snack', 3E3);
        });
      },
    openModal(ref) {
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
    },
   
  },
  mounted() {
    this.cart = window.cart;
    this.isLogged = localStorage.getItem("cliente") ? true : false;
    this.parametros = localStorage.getItem('parametros') ? JSON.parse(localStorage.getItem('parametros')) : {};
    this.empresa = localStorage.getItem('empresa') ? JSON.parse(localStorage.getItem('empresa')) : {};  
    this.ultimaPagina = localStorage.getItem('ultimaPagina');  
    if (this.isLogged === true){
      this.$router.push({ name: this.ultimaPagina});
    }
  }
};
</script>

<style lang="scss">
  @import '../../config/theme/theme.scss';
  #ForgotPassword {
    color: $primary-color;
    margin-top: -10px;
    font-style: italic;
    text-decoration: underline;
    cursor: pointer;
  }
    // .articulo-card{
    //     margin:10px;
    //     width:100%;
    //     img{
    //        max-height: 130px;
    //        max-width: 130px;
           
    //     }
    //     .descripcion {
    //         // height:215px;
    //         text-align: justify;
    //         height:50px;
    //         margin-bottom:10px;
    //         .md-tooltip{
    //             max-width: 100px !important;
    //         }
    //     }
    //     .md-card-actions{
            
    //     }
    // }
    // #dialogDetalle{
    //   .md-dialog{
    //     width:650px;
    //     }
    // }
    // .precio{
    //   font-size: 18px;
    //   font-weight: bold;
    //   opacity: .8;
    //   margin-top: 20px;
    // }
    // .existencia {
    //   font-size:14px;
    //   font-weight: 500;
    //   text-align: center;
    //   // margin-right: auto;
    //   padding: 5px 0px;
    //   .agotado{
    //     // background-color: #FF0000;
    //     color:#FF0000;

    //   }
    //   .disponible{
    //     // background-color: #01DF01;
    //     color:#04B431;

    //   }

    // }
</style>




// WEBPACK FOOTER //
// src/spa/login/login.vue